import type { FC } from "react";

type KycButtonProps = {
    title: string;
    description: string;
    image: JSX.Element;
    onClick: () => void;
};

export const KycButton: FC<KycButtonProps> = ({ title, description, image, onClick }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className={
                "w-full max-w-md border-2 border-brand-primary px-6 py-4 shadow-sm transition-colors duration-200 hover:border-brand-secondary hover:bg-brand-secondary hover:text-brand-white"
            }
        >
            <div className="flex">
                <div className="flex-1 text-left">
                    <h3 className="mb-2 text-sm font-semibold">{title}</h3>
                    <p className="text-xs leading-tight">{description}</p>
                </div>

                <div className="ml-4 flex items-center justify-center">{image}</div>
            </div>
        </button>
    );
};
